import { Injectable } from '@angular/core';
import { BackendHttpService } from '../../core/backend-http.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class OverviewService extends BackendHttpService<any> {
  constructor(
    protected router: Router,
    protected translate: TranslateService,
    protected http: HttpClient
  ) {
    super(router, translate);
  }
  public searchDashboardPost() {
    // Here we put mock data
    return this.http.get('/assets/mock-data/dashboard-posts.json');
  }

  fetchRecentMessages() {
    // Todo: This is mock data
    return Observable.of([
      { status: 1, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 1, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
      { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/overview/overview.service.ts